import React from "react";

function Header({ isNavOpen, onOpenNav }) {
  return (
    <header className="site-header">
      <div className="header-content">
        <div className="header-left">
          <div className="header-brand">
            <span className="header-initial">EC</span>
            <div className="header-text">
              <span className="header-name">Enrico Cuomo</span>
              <span className="header-tag">Technology · Business · Creativity</span>
            </div>
          </div>
        </div>

        <div className="header-right">
          <button
            className={`menu-icon ${isNavOpen ? "is-active" : ""}`}
            aria-expanded={isNavOpen}
            aria-label="Menu di navigazione"
            onClick={onOpenNav}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
